import api from './api';

// API Providers API calls
export const getAPIProviders = async () => {
  const response = await api.get('/admin/core/api-providers/');
  return response;
};

export const getAPIProvider = async (id) => {
  const response = await api.get(`/admin/core/api-providers/${id}/`);
  return response;
};

export const createAPIProvider = async (providerData) => {
  const response = await api.post('/admin/core/api-providers/', providerData);
  return response;
};

export const updateAPIProvider = async (id, providerData) => {
  const response = await api.put(`/admin/core/api-providers/${id}/`, providerData);
  return response;
};

export const deleteAPIProvider = async (id) => {
  const response = await api.delete(`/admin/core/api-providers/${id}/`);
  return response;
};

// API Keys API calls
export const getAPIKeys = async (params = {}) => {
  const response = await api.get('/admin/core/api-keys/', { params });
  return response;
};

export const getAPIKey = async (id) => {
  const response = await api.get(`/admin/core/api-keys/${id}/`);
  return response;
};

export const createAPIKey = async (keyData) => {
  const response = await api.post('/admin/core/api-keys/', keyData);
  return response;
};

export const updateAPIKey = async (id, keyData) => {
  const response = await api.put(`/admin/core/api-keys/${id}/`, keyData);
  return response;
};

export const deleteAPIKey = async (id) => {
  const response = await api.delete(`/admin/core/api-keys/${id}/`);
  return response;
};

export const activateAPIKey = async (id) => {
  const response = await api.post(`/admin/core/api-keys/${id}/activate/`);
  return response;
};

// API Usage Logs API calls
export const getAPIUsageLogs = async (params = {}) => {
  const response = await api.get('/admin/core/api-usage-logs/', { params });
  return response;
};

export const clearAPIUsageLogs = async () => {
  const response = await api.delete('/admin/core/api-usage-logs/clear/');
  return response;
};

export const getAPIUsageSummary = async (params = {}) => {
  const response = await api.get('/admin/core/api-usage-summary/', { params });
  return response;
};

// API Statistics API calls
export const getAPIStatistics = async (params = {}) => {
  const response = await api.get('/admin/core/api-statistics/', { params });
  return response;
};
